import { render, staticRenderFns } from "./GridLoteArquivos.vue?vue&type=template&id=3112a6c8&"
import script from "./GridLoteArquivos.vue?vue&type=script&lang=js&"
export * from "./GridLoteArquivos.vue?vue&type=script&lang=js&"
import style0 from "./GridLoteArquivos.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports